import { render, staticRenderFns } from "./ShowDiscussionSubComments.vue?vue&type=template&id=97dd311e&"
import script from "./ShowDiscussionSubComments.vue?vue&type=script&lang=js&"
export * from "./ShowDiscussionSubComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports